var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf",
    x1: 112,
    y1: 112.3,
    x2: 158,
    y2: 112.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf",
    x1: 74.4,
    x2: 120.4,
    xlinkHref: "#SVGID_0_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf",
    x1: 36.8,
    x2: 82.8,
    xlinkHref: "#SVGID_0_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M57.3 85.3V44.9M117.5 133.4h-13.6M79.8 22.4h59.9v66.4M79.9 133.4H66.3M79.8 22.4L57.3 44.9h22.5V22.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf)",
    d: "M156.8 112.3l-19.6 27h-23.9l19.5-27-19.5-27h23.9l19.6 27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1 MI_4L_gradient",
    stroke: "url(#SVGID_1_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf)",
    d: "M119.2 112.3l-19.6 27h-24l19.6-27-19.6-27h24l19.6 27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0 MI_4L_gradient",
    stroke: "url(#SVGID_2_bf4b976736ce09cc527be4ea404a99d9fc81a6638177a15166b7e94bb0833acf)",
    d: "M81.5 112.3l-19.5 27H38l19.6-27-19.6-27h24l19.5 27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M93.1 54.9h37.1M71.8 67.1h58.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrSubmissions);
export default __webpack_public_path__ + "static/media/prSubmissions.26e42eb5f339d1fc02f1d9c239313b5c.svg";
export { ForwardRef as ReactComponent };